<template>
  <div class="field">
    <div>
      <span>已选标签：</span>
      <span v-if="!value.length">无</span>
      <div v-for="t in value" :key="t" class="ui tag blue label cursor-pointer" @click="remove_tag(t)">
        <i class="tag icon"></i>
        {{ t }}
      </div>
    </div>
    <div class="my-2">
      <span>可用标签：</span>
      <span v-if="!usable_tags">无标签</span>
      <div v-for="t in usable_tags" :key="t" class="ui tag label cursor-pointer" :class="tag_class(t)" @click="add_tag(t)">
        <i class="tag icon"></i>
        {{ t }}
      </div>
    </div>
    <div class="ui fluid action input" v-if="!hide_create">
      <input :id="'new-tag-input'+_uid" name="new-tag-input" maxlength="128" v-model.trim="new_tag" @keyup.enter="create_tag" type="text" />
      <div class="ui button">
        <div @click="create_tag">
          新建标签
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TagInput',
  props: ['value', 'hide_create'],
  components: {
  },
  data: function () {
    return {
      new_tag: '',
    };
  },
  computed: {
    pwdata() {
      return this.$store.state.pwdata;
    },
    usable_tags() {
      return this.pwdata.tags.filter(t => !this.selected_tag(t));
    },
  },
  methods: {
    selected_tag(t) {
      for (var x of this.value) {
        if (x == t) {
          return true;
        }
      }
      return false;
    },
    tag_class(t) {
      if (this.value.includes(t)) {
        return "d-none";
      } else {
        return "btn-secondary";
      }
    },
    emit_input(value) {
      this.$emit("input", value);
    },
    remove_tag(t) {
      var value = this.value.filter(x => x != t);
      this.emit_input(value);
    },
    add_tag(t) {
      var value = this.value;
      if (!value.length) {
        value = [];
      }
      if (value.some(v => v == t)) {
        return;
      }
      this.emit_input(value.concat(t));
    },
    create_tag() {
      if (!this.new_tag) {
        return;
      }
      if (this.usable_tags.some(t => t == this.new_tag)) {
        this.show_error("标签已存在");
        return;
      }
      var tag = this.new_tag;
      this.new_tag = '';
      this.add_tag(tag);
      this.$store.dispatch('pwdata_create_tag', tag).then(() => {
        this.show_success("标签已创建: " + tag);
      }).catch(e => {
        this.show_error("添加标签失败: " + e.message);
      });
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
</style>
